import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import {
  BaseComponent,
  LoadingState,
  MessageBus,
  SearchResult,
  TextAreaControlComponent,
  isBlank,
  ProgressService,
} from 'src/app/shared';
import { CommCenterService, LogService } from '../..';
import {
  CommCenterMessage,
  SaveMessageActionRequest,
  SendMessage,
} from '../../models/Communications';
import { ConversationSummary } from '../../models/ConversasationSummary';
import { emulator } from '../../services/emulator.service';
import { InpageAliasService } from '../../services/inpage-alias.service';
import { Session } from '../../services/session.service';
import { UserRoleService } from '../../services/user-role.service';
import { srSpeak } from 'src/app/shared';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ConfigurationService } from '../../services/configuration.service';
import { ConfigurationSetting } from '../../../shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Aliases } from '../../models/aliases';

@Component({
    selector: 'app-comm-center2-messages',
    template: `
    <app-loading-panel
      [state]="loadingState"
      loadingStyle="Box"
      [loadingHeight]="400"
      >
      <div init class="tw-min-h-[400px] tw-pt-[100px]">
        <app-empty-state-label
          icon="message"
          header="View conversation"
          message="Select a claim to view or begin a conversation."
          >
        </app-empty-state-label>
      </div>
      <ng-template #content>
        @if(headerEnabled) {
          <div class="tw-flex tw-flex-wrap tw-w-full" title="">
            <div class="md:tw-block sm:tw-block sm:tw-w-[100%] md:tw-w-[50%]">
              <app-claimant-label value [claimant]="summary">
              </app-claimant-label>
            </div>
            <div class="md:tw-block sm:tw-block sm:tw-w-[100%]  md:tw-w-[50%]">
              <div class="mdfloatRight">
                <app-claim-label
                  value
                  [claim]="summary"
                  layout="row"
                  [disabled]="false"
                  [hideWatchList]="true"
                ></app-claim-label>
              </div>
            </div>
            @if (shouldShowCompanionToast()) {
              <div>
                <app-toast type="Info">
                  {{'Your Leave claim is a companion to claim' | translation : translationRequest}}
                  <a
                    class="tw-text-white link-color hover:tw-text-white hover:tw-decoration-white"
                    routerLink="/claims"
                [queryParams]="{
                            claimId: companionClaim.claimId,
                            source: companionClaim.source,
                          }"
                    >{{ companionClaim.claimNumber }}</a
                    >. {{'All messages sent on the Leave claim are centralized on the main claim.' | translation : translationRequest}}
                  </app-toast>
                </div>
              }
            </div>
          } @else if (shouldShowCompanionToast()) {
            <div class="md:tw-block tw-hidden tw-w-[100%]">
              <app-toast type="Info">
                {{'Your Leave claim is a companion to claim' | translation : translationRequest}}
                <a
                  class="tw-text-white link-color hover:tw-text-white hover:tw-decoration-white"
                  routerLink="/claims"
              [queryParams]="{
                      claimId: companionClaim.claimId,
                      source: companionClaim.source,
                    }"
                  >{{ companionClaim.claimNumber }}</a
                  >. {{'All messages sent on the Leave claim are centralized on the main claim.' | translation : translationRequest}}
                </app-toast>
              </div>
            }
            <div
              class="tw-pb-6"
              appOverflow
              [overflowHeight]="overflowHeight"
              [overflowScrollBottom]="true"
              #container
              >
              <div class="tw-flex tw-flex-wrap tw-w-full" title="">
                <div class="tw-w-full  tw-pt-6 "></div>
    
                @if (!isEmulating) {
                  @for (message of messages; track message) {
                    <div
                      class="examiner-container app-pb2  tw-w-full tw-flex"
                      id="contentScroll"
                      >
                      <div class="tw-flex-none">
                        <mat-icon class="icon">{{
                          message.examiner ? 'support_agent' : 'face'
                        }}</mat-icon>
                      </div>
                      <div class="tw-flex-auto">
                        <div class="sender">
                          {{ getSenderDisplay(message) + ' - ' | titlecase }}
                          {{ (message.date | timeSince) | translation : translationRequest }}
                          @if (message.unread) {
                            <span class="app-indicator tw-ml-1"
                              >{{'New' | translation : translationRequest}}</span
                              >
                            }
                            @if (message.read) {
                              <span class="app-indicator tw-ml-1"
                                >{{'READ' | translation : translationRequest}}</span
                                >
                              }
                              <div class="messageDate">
                                {{ message.date | format : 'dateTime' }}
                              </div>
                            </div>
                            <div class="tw-flex">
                              <div
                                class="message-div tw-grow-0 text-breaking"
                      [ngClass]="{
                        'examiner-message': message.examiner,
                        'user-message': !message.examiner
                      }"
                                >
                                {{ message.value }}
                              </div>
                              <div class="tw-grow"></div>
                            </div>
                          </div>
                        </div>
                      }
                    }
    
                    @if(canSendMessage && !isLitigatedClaim) {
                      @if (messages?.length === 0) {
                        <div class="app-pt2 tw-w-full">
                          <app-empty-state-label icon="mail_outline" header="No messages">
                            <app-toast [message]="startConvoMessage"></app-toast>
                          </app-empty-state-label>
                        </div>
                      }
                      <div class="app-pt2 tw-w-full">
                        <form [formGroup]="formGroup">
                          <app-text-area-control
                            id="commCenterInput"
                            label="Type a message..."
                            ngDefaultControl
                            [formGroup]="formGroup"
                            formControlName="message"
                            [maxLength]="1000"
                            [rows]="2"
                            (keypress)="onKeyPressEvent($event)"
                            [disabled]="isSending"
                            #messageTextarea
                            [ariaDescribedBy]="'commCenterInputError'"
                          ></app-text-area-control>
                          @if (this.errorMessage) {
                            <div>
                              <span
                                id="commCenterInputError"
                                class="errorMsg"
                    [attr.aria-live]="
                      this.errorMessage ? 'assertive' : 'polite'
                    "
                                >
                                {{ 'Error : Please enter a message' | translation : translationRequest }}</span
                                >
                              </div>
                            }
    
                            <div class="tw-pr-2 tw-w-full">
                              @if (sentSuccess === true) {
                                <app-toast type="Info" [message]="thankyouToast">
                                </app-toast>
                              }
                            </div>
                          </form>
    
                          <div class="tw-w-full tw-flex tw-flex-wrap">
                            <div class="tw-w-full md:tw-w-[53%]">
                              @if (isUploadDocuments) {
                                <app-action-link
                                  imageUrl="./assets/images/upload.png"
                                  title="Upload Documents"
                                  helpText=""
                                  [routerLink]=""
                                  [imageWidth]="45"
                                  [imageHeight]="53"
                                  (click)="handleUploadDocument()"
                                  (keydown.enter)="handleUploadDocument()"
                                ></app-action-link>
                              }
                            </div>
                            <div class="tw-flex tw-justify-end tw-w-full ">
                              <app-action-row>
                                <app-button
                                  right2
                                  autofocus
                                  (click)="sendMsg()"
                                  emphasis="High"
                                  [id]="'sendMessage'"
                                  [loading]="isSending"
                                  label="Send"
                                  ></app-button
                                  >
    
                                  <app-button
                                    right1
                                    id="btnCancel"
                                    (click)="clearMsg()"
                                    emphasis="Low"
                                    label="Clear"
                                    ></app-button
                                    >
                                  </app-action-row>
                                </div>
                              </div>
                            </div>
                          } @else if(isLitigatedClaim) {
                            <div class="app-pt2 tw-w-full">
                              <app-empty-state-label icon="mail_outline" header="No messages">
                                <app-toast [message]="litigatedClaimMessage"></app-toast>
                              </app-empty-state-label>
                            </div>
                          } @else {
                            <div class="app-pt2 tw-w-full">
                              <app-empty-state-label icon="mail_outline" header="No messages">
                                <app-toast
                                  >{{'For additional information regarding closed claims, please contact your' | translation : translationRequest}} {{ examinerLabel | aliasTransform:'none' }}. {{ contactNumber }}
                                </app-toast>
                              </app-empty-state-label>
                            </div>
                          }
                          <div class="tw-w-full md:tw-w-[53%]">
                            @if (
                              isUploadDocuments && !(canSendMessage && !isLitigatedClaim)
                              ) {
                              <app-action-link
                                imageUrl="./assets/images/upload.png"
                                title="Upload Documents"
                                helpText=""
                                [routerLink]=""
                                [imageWidth]="45"
                                [imageHeight]="53"
                                (click)="handleUploadDocument()"
                                (keydown.enter)="handleUploadDocument()"
                              ></app-action-link>
                            }
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </app-loading-panel>
    `,
    styles: [
        `
      .file-input {
        display: none;
      }

      .listScroll {
        overflow-y: scroll;
        height: 160px;
      }
      .contentScroll {
        overflow-y: scroll;
        background-color: #f0f4f7;
      }

      .errorMsg {
        font-weight: bold;
        color: #c24533 !important;
      }
      .errorMsg:focus {
        color: var(--color-warn);
        font-weight: bold;
        outline-color: var(--color-warn) !important;
      }

      ::ng-deep .commCenterName {
        font-weight: bold;
      }
      .mdfloatRight {
        float: right;
      }
      @media only screen and (max-device-width: 480px) {
        .icon {
          display: none;
        }

        .mdfloatRight {
          float: none;
        }
        ::ng-deep .commactionbtn {
          padding-right: 30px !important;
        }
      }

      .messageDate {
        float: right;
        margin-right: 10px;
      }
      .examiner-container {
      }
      .icon {
        font-size: 40px;
        width: 40px;
        height: 40px;
        color: var(--color-accent);
        margin-top: 18px;
      }
      .user-message {
        background-color: #e9edf2;
        border-radius: 0 8px 8px;
        margin-left: 8px;
      }
      .message-div {
        margin-right: 10px;
        padding: 12px 16px 12px 16px;
      }
      .examiner-message {
        background-color: var(--sed-purple-40-color);
        color: var(--sed-engaged-black-color);
        border-radius: 0 8px 8px;
        margin-left: 8px;
      }
      .sender {
        font-size: 12px;
        margin-left: 24px;
        font-weight: bold;
        padding-bottom: 4px;
        color: var(--color-input-grey);
      }

      .text-breaking {
        word-break: break-all;
      }

      .link-color {
        color: var(--sed-dynamic-black-color);
      }
    `,
    ],
    standalone: false
})
export class CommCenter2MessagesComponent
  extends BaseComponent
  implements OnInit, AfterViewChecked
{
  @ViewChild('container', { static: false })
  container: ElementRef;

  @ViewChild('messageTextarea')
  messageTextArea: TextAreaControlComponent;

  @Input()
  claim: SearchResult;

  @Input()
  summary: ConversationSummary;

  @Input()
  companionClaim: SearchResult = null;

  @Input()
  headerEnabled = true;

  @Input()
  translationRequest: TranslationRequest;

  @Input()
  overflowHeight: string = null;

  @Input()
  focus: boolean;

  @Output()
  conversationUpdated: EventEmitter<ConversationSummary> = new EventEmitter();

  messages: CommCenterMessage[];

  examinerLabel: Aliases;

  contactNumber: string;

  formGroup = this.fb.group({
    date: [],
    sender: [],
    message: [],
    read: [],
  });

  sentSuccess: boolean = false;

  isSending: boolean = false;

  errorMessage: string = '';

  isEmulating: boolean = false;

  canSendMessage: boolean;

  loadingState: LoadingState = 'Init';

  messageAreaFocusRequested: boolean = false;

  isLitigatedClaim: boolean = false;

  thankyouToast: string =
    'Thank you for your message. It has been sent and a response will be provided here within one business day.';

  startConvoMessage: string =
    'Send a message to start a conversation for this claim';

  litigatedClaimMessage: string =
    'Our records indicate you are represented by an attorney. Please direct any questions or communication regarding your claim to your attorney.';

  isUploadDocuments: boolean = false;
  canUploadOnClaim: boolean = false;
  claimId: string;
  source: string;
  conversations: ConversationSummary[] = [];
  claimConfig: ConfigurationSetting;

  constructor(
    private fb: UntypedFormBuilder,
    private commCenterService: CommCenterService,
    private alias: InpageAliasService,
    private enumalatorService: emulator,
    private session: Session,
    public userRole: UserRoleService,
    private messageBus: MessageBus,
    public claimConfigService: ConfigurationService,
    public dialog: MatDialog,
    public logService: LogService,
    public progressService: ProgressService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute
  ) {
    super();
    this.subs.sink = this.messageBus
      .topic('comm-center-messages:focus')
      .subscribe(() => {
        this.messageAreaFocusRequested = true;
        //this.messageTextArea?.focus();
      });
  }

  async ngOnInit() {
    const config = await this.claimConfigService.getAdditionalUserInformation();
    this.examinerLabel = await this.alias.replaceAliases(
      'examinerSingular',
      config.configFeatures.aliases
    );
    this.contactNumber = await this.alias.get('phone');
    this.isEmulating = this.session.user?.emulatorContext?.isEmulating;
    const from = this.route.snapshot.queryParamMap.get('from');
    const claimId = this.route.snapshot.queryParamMap.get('claimId');
    const source = this.route.snapshot.queryParamMap.get('source');
    if (from == 'commcenter') {
      let messagelst = (this.conversations =
        await this.commCenterService.getMyConversations());
      this.conversations = messagelst.filter((x) => x.claimId === claimId);
      if (this.conversations.length == 0) {
        messagelst = this.conversations =
          await this.commCenterService.getManagerConversations();
        this.conversations = messagelst.filter((x) => x.claimId === claimId);
      }
      await this.loadConversationMessages(this.conversations[0]);

      // setTimeout(() => {
      //   debugger;
      //   const authorizeYes = document.getElementById(
      //     'tabGroupId'
      //   ) as HTMLInputElement;
      // }, 2000);
    }

    if (this.summary) {
      await this.loadConversationMessages(this.summary);
    } else {
      // no conversation exists yet, need to create new conv depending on if userowns or not

      if (this.claim) {
        this.summary = await this.commCenterService.getClaimConversation(
          this.claim.source,
          this.claim.claimId
        );

        this.claimId = this.claim.claimId;
        this.source = this.claim.source;

        // starting conversation on claim from summary page that has no previous messages
        if (this.claim.userOwns) {
          // create new conversation under myconversations on service
          this.addNewConversation(this.commCenterService.myConversations);
        } else {
          // create new conversation under managerconversations on service
          this.addNewConversation(this.commCenterService.managerConversations);
        }
      }
    }
  }

  ngAfterViewChecked() {
    // adding this because the focus doesnt shift on the first click after page load
    if (this.messageAreaFocusRequested) {
      this.messageTextArea?.focus();
      this.messageAreaFocusRequested = !this.messageAreaFocusRequested;
    }
  }

  addNewConversation(convArray: ConversationSummary[]) {
    const existingConv = convArray.filter(
      (m) => m.claimId == this.claim.claimId && m.source == this.claim.source
    );
    if (existingConv.length > 0) {
      this.summary = existingConv[0];
      if (this.summary.sourceClaimKey) {
        this.companionClaim = this.summary.sourceClaimKey;
      }
    } else {
      const newConv = new ConversationSummary();
      if (
        (this.claim.source === 'T' || this.claim.source === 'J') &&
        this.claim.companionClaims?.length > 0
      ) {
        // NEED TO LOOK UP PRIMARY CLAIM FROM SELECTED CLAIM INFO
        const firstJurisCompClaim = this.claim.companionClaims.filter(
          (cc) => cc.recordSource == (this.claim.source === 'T' ? 'J' : 'T')
        );
        if (firstJurisCompClaim?.length > 0) {
          const jClaim = firstJurisCompClaim[0];
          this.companionClaim = {
            claimId: jClaim.claimUid,
            claimNumber: jClaim.fileNum,
            source: jClaim.recordSource,
          } as any;

          // add new conversation data if needed for UI
        }
      }

      newConv.claim = this.claim;

      newConv.claimId = this.claim.claimId;
      newConv.claimDescription = this.claim.claimDescription;
      newConv.source = this.claim.source;
      newConv.claimNumber = this.claim.claimNumber;
      newConv.name = this.claim.name;
      newConv.details = [];
      newConv.empId = this.claim.empId;

      newConv.empUnum = this.claim.empUnum;

      //curConv = newConv;
      convArray.push(newConv);
      this.summary = newConv;
      //this.conversationsList.updateDataSource();
    }
  }

  async loadConversationMessages(summary: ConversationSummary) {
    if (!summary) {
      if (this.claim) {
        summary = await this.commCenterService.getClaimConversation(
          this.claim.source,
          this.claim.claimId
        );
      }
    }

    const claimId = this.route.snapshot.queryParamMap.get('claimId');

    if (claimId == null) {
      this.FeatureLoggingWithClaim(
        'CommunicationCenter',
        'Communication Center',
        'View',
        summary
      );
    }
    // this.claimConfig = await this.claimConfigService.getClaimConfiguration(
    //   summary
    // );
    // this.canUploadOnClaim =  this.claimConfig.features.indexOf('uploaddocuments') > -1;
    //this.claimConfigService.getFeatureAccess('uploaddocuments');

    await this.uploadDocumentLOBBased(
      'UploadDocuments',
      summary.status,
      summary.lob
    );
    this.loadingState = 'Loading';
    this.companionClaim = null;
    const paramFrom = this.route.snapshot.queryParamMap.get('from');
    // const paramClaimId = this.route.snapshot.queryParamMap.get('claimid');
    // const paramSource = this.route.snapshot.queryParamMap.get('source');
    // if (paramFrom) {
    //   this.claimId = paramClaimId;
    //   this.source = paramSource;
    // } else {
    //   this.claimId = summary.claimId;
    //   this.source = summary.source;
    // }
    this.claimId = summary.claimId;
    this.source = summary.source;
    if (
      summary.sourceClaimKey &&
      summary.claimId != summary.sourceClaimKey.claimId
    ) {
      this.companionClaim = summary.sourceClaimKey;
      this.companionClaim.status = summary.status;
    }
    this.sentSuccess = false;
    this.errorMessage = null;
    this.summary = summary;

    this.messages = summary.details ?? (summary.details = []);
    this.markUnreadMessagesAsRead();
    this.formGroup.controls['message'].setValue(null);
    const claimstatus = this.summary.claim?.status ?? this.summary.status;
    this.canSendMessage = !claimstatus?.toLowerCase().includes('closed');
    this.loadingState = 'Loaded';

    if (this.summary) {
      this.isLitigatedClaim =
        this.summary.isLitigated && this.summary.lineOfBusiness !== 'DS';
    }

    if (this.focus) {
      this.focus = false;
      setTimeout(() => {
        this.messageTextArea?.focus();
      }, 0);
    }
  }

  onKeyPressEvent(event: any) {
    if (event.target.value == '\n') {
      this.formGroup.controls['message'].setValue('');
    }
  }

  shouldUseCompanionClaim(): boolean {
    if (!this.companionClaim || !this.summary) {
      return false;
    }

    const summaryStatus = this.summary.claim?.status ?? this.summary.status;
    const companionStatus = this.companionClaim.status;
    const isSummaryOpen = !this.isClaimClosed(summaryStatus);
    const isCompanionOpen = !this.isClaimClosed(companionStatus);

    return isSummaryOpen && isCompanionOpen;
  }

  isClaimClosed(status: string): boolean {
    return status.toLowerCase().includes('closed');
  }

  getTargetClaimForMessaging(): any {
    const currentSource = this.summary?.source;
    if (currentSource === 'J') {
      return this.summary;
    }

    if (currentSource === 'T') {
      const shouldUseCompanion = this.shouldUseCompanionClaim();

      if (shouldUseCompanion && this.companionClaim) {
        return this.companionClaim;
      } else {
        return this.summary;
      }
    }

    return this.summary;
  }

  shouldShowCompanionToast(): boolean {
    const currentSource = this.summary?.source;
    if (currentSource !== 'T') {
      return false;
    }
    return this.companionClaim && this.shouldUseCompanionClaim();
  }

  updateMessageDisplayAfterSend(
    message: CommCenterMessage,
    results: any
  ): void {
    this.summary.messageId = results.messageId;
    this.summary.date = new Date(message.date);
    this.summary.details.push(message);
  }

  async sendMsg() {
    if (this.isSending) {
      return;
    }

    this.sentSuccess = false;
    this.errorMessage = '';
    const msgText = this.messageTextArea.formControl.value;
    if (isBlank(msgText)) {
      this.errorMessage = 'Error : Please enter a message';
      this.messageTextArea.focus();
      //srSpeak(this.errorMessage, 'polite');
      return;
    }

    this.isSending = true;
    this.enumalatorService.showAuditorInfo();
    const targetClaim = this.getTargetClaimForMessaging();

    const message = new CommCenterMessage();
    const request = new SendMessage();
    if (this.summary.messageId == null) {
      request.messageId = undefined;
    } else {
      request.messageId = Array.isArray(this.summary.messageId)
        ? this.summary.messageId[0]
        : this.summary.messageId;
    }
    //console.log(request.messageId);
    request.messageText = msgText;
    request.empUNum = targetClaim.empUnum;
    request.userOwns = targetClaim.userOwns;
    request.claimNumber = targetClaim.claimNumber;
    request.createdTS = new Date();

    const results = await this.commCenterService.saveMessage(
      targetClaim.source,
      targetClaim.claimId,
      targetClaim.lob,
      request
    );

    message.examiner = false;
    message.value = request.messageText;
    message.date = new Date(results.date);
    message.sender = results.name;

    this.updateMessageDisplayAfterSend(message, results);
    this.sentSuccess = true;
    srSpeak(this.thankyouToast, 'polite');
    this.messageTextArea.formControl.reset();
    this.messageTextArea.focus();
    this.isSending = false;
    this.conversationUpdated.emit();

    setTimeout(() => {
      this.container.nativeElement.scrollTo(
        0,
        this.container.nativeElement.scrollHeight
      );
    }, 0);
  }

  clearMsg() {
    this.messageTextArea.formControl.reset();
    this.messageTextArea.focus();
  }

  markUnreadMessagesAsRead() {
    for (const message of this.messages) {
      if (message.unread) {
        const request: SaveMessageActionRequest =
          new SaveMessageActionRequest();
        request.ClaimNumber = this.summary.claimNumber;
        request.ContNum = this.summary.contNum;
        request.CorrelationId = message.correlationId;
        request.ConversationDetailId = message.detailId;
        request.MessageId = this.summary.messageId[0];
        request.SourceSystem = this.summary.source;

        this.commCenterService
          .readMessage(
            this.summary.source,
            this.summary.claimId,
            this.summary.lob,
            request
          )
          .then(() => {
            const isEmulating =
              this.session.user &&
              this.session.user?.emulatorContext &&
              this.session.user?.emulatorContext?.isEmulating;

            if (!isEmulating) {
              message.unread = false;
              message.read = true;
              this.summary.unread =
                this.summary.details.filter((fd) => fd.unread)?.length > 0;
              this.commCenterService.updateUnreadCount();
            }
          });
      }
    }
  }

  getSenderDisplay(message: CommCenterMessage) {
    if (!message.examiner) {
      const lastSenderSeparater = message.sender.lastIndexOf(' ');
      if (lastSenderSeparater > 0) {
        const firstSenderPart = message.sender.substring(
          0,
          lastSenderSeparater
        );

        const lastSenderPart =
          message.sender.substring(
            lastSenderSeparater + 1,
            lastSenderSeparater + 2
          ) + '.';

        return firstSenderPart + ' ' + lastSenderPart;
      }
    }

    return message.sender;
  }

  handleUploadDocument() {
    const queryParams: any = {};
    const paramFrom = this.route.snapshot.queryParamMap.get('from');
    //const paramClaimId = this.route.snapshot.queryParamMap.get('claimId');
    //const paramSource = this.route.snapshot.queryParamMap.get('source');
    if (this.location.path() === '/communication-center') {
      queryParams.from = 'commcenter';
    } else if (paramFrom == 'commcenter') {
      queryParams.from = 'commcenter';
    } else {
      queryParams.from = 'claim';
    }

    queryParams.focus = 'documents';
    queryParams.claimId = this.claimId; //== null ? paramClaimId : this.claimId;
    queryParams.source = this.source; //== null ? paramSource : this.source;
    queryParams.showDialog = true;
    const targetUrl = this.router
      .createUrlTree(['/upload-documents-in-documentstab'], { queryParams })
      .toString();
    if (this.location.path() === targetUrl) {
      window.location.reload(); //when coming back from upload to summary tab if the url is the same it doesnt redirect so need to reload
    } else {
      this.router.navigate(['/upload-documents-in-documentstab'], {
        queryParams,
      });
    }
  }

  async uploadDocumentLOBBased(
    featureName: string,
    status: string,
    lob: string
  ) {
    const lobConfigs = await this.claimConfigService.getFeatureLobs(
      'UploadDocuments'
    );
    const lobConfigsClosed = await this.claimConfigService.getFeatureLobs(
      'UploadOnClosedClaim'
    );
    lobConfigs.forEach((updatedLOB) => {
      if (
        updatedLOB.value.toUpperCase() == 'FM' ||
        updatedLOB.value.toUpperCase() == 'LV' ||
        updatedLOB.value.toUpperCase() == 'LA'
      ) {
        updatedLOB.value = 'LV';
      }
    });

    lobConfigsClosed.forEach((updatedLOB) => {
      if (
        updatedLOB.value.toUpperCase() == 'FM' ||
        updatedLOB.value.toUpperCase() == 'LV' ||
        updatedLOB.value.toUpperCase() == 'LA'
      ) {
        updatedLOB.value = 'LV';
      }
    });

    const convertedLOB = await this.returnLOB(lob);
    const convertedLOBClosed = await this.returnLOB(lob);

    if (status?.toLowerCase().includes('closed')) {
      if (lobConfigsClosed.some((x) => x.value == convertedLOBClosed)) {
        this.isUploadDocuments = true;
      } else {
        this.isUploadDocuments = false;
      }
    } else {
      if (lobConfigs.some((x) => x.value == convertedLOB)) {
        this.isUploadDocuments = true;
      } else {
        this.isUploadDocuments = false;
      }
    }
  }

  async returnLOB(lob: string) {
    if (
      lob.toUpperCase() == 'FM' ||
      lob.toUpperCase() == 'LV' ||
      lob.toUpperCase() == 'LA'
    ) {
      return 'LV';
    } else {
      return lob;
    }
  }
}
